import { render, staticRenderFns } from "./AccountTwoFaIntro.vue?vue&type=template&id=5fb6116a&scoped=true"
import script from "./AccountTwoFaIntro.vue?vue&type=script&lang=js"
export * from "./AccountTwoFaIntro.vue?vue&type=script&lang=js"
import style0 from "./AccountTwoFaIntro.vue?vue&type=style&index=0&id=5fb6116a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6116a",
  null
  
)

export default component.exports